import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';
import { RouterService } from '@app/routing/router.service';
import { TypeaheadEntry } from '@app/shared/services/typeahead-basket.service';
import { Cached } from '@app/utils/cached';
import { reduceBooleans$ } from '@app/utils/rxjs';
import { TrunkDetailViewModel } from '@business/trunk/models/trunk-detail-view-model';
import { TrunkViewModel } from '@business/trunk/models/trunk-view-model';
import { TrunksViewModel } from '@business/trunk/models/trunks-view-model';
import { TrunkService } from '@business/trunk/services/trunk.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-enterprise-trunk-sub-nav',
  templateUrl: './enterprise-trunk-sub-nav.component.html',
  styles: [],
  standalone: false,
})
export class EnterpriseTrunkSubNavComponent extends SubNavBaseComponent implements OnDestroy, OnInit {
  loading$: Observable<boolean> | null = null;
  trunk$: Observable<TrunkViewModel> | null = null;
  trunks$: Observable<TrunksViewModel> | null = null;
  typeaheadTrunks$: Observable<TypeaheadEntry<string>[]> | null = null;

  trunk: Cached<TrunkDetailViewModel> | null = null;
  trunks: Cached<TrunksViewModel> | null = null;

  private takeUntil$: Subject<void>;

  constructor(
    private routerService: RouterService,
    private trunkService: TrunkService
  ) {
    super();
  }

  ngOnDestroy() {
    this.takeUntil$?.next();
    this.takeUntil$?.complete();
  }

  ngOnInit() {
    this.loading$ = new BehaviorSubject<boolean>(true);
  }

  loadTrunk(visible: boolean) {
    if (visible) {
      this.takeUntil$?.next();
      this.takeUntil$?.complete();

      this.takeUntil$ = new Subject<void>();

      this.trunk = this.trunkService.trunkDetails;
      this.trunks = this.trunkService.list;

      this.trunk$ = this.trunk.data$.pipe(
        map((viewModel) => viewModel.trunk),
        takeUntil(this.takeUntil$)
      );

      this.trunks$ = this.trunks.data$.pipe(takeUntil(this.takeUntil$));
      this.typeaheadTrunks$ = this.trunks$.pipe(
        map((viewModel) =>
          viewModel.trunks.map((trunk) => {
            return {
              key: `${trunk.name} ${trunk.description}`,
              label: `<span>${trunk.name}</span> <small>${trunk.description}</small>`,
              meta: {
                isTeamsTrunk: trunk.isTeamsTrunk,
              },
              value: trunk._original.db.number,
            } as TypeaheadEntry<string>;
          })
        ),
        takeUntil(this.takeUntil$)
      );

      this.loading$ = reduceBooleans$([this.trunks.loading$, this.trunk.loading$]).pipe(
        takeUntil(this.takeUntil$)
      );
    } else {
      this.takeUntil$?.next();
      this.takeUntil$?.complete();

      this.trunk = null;
      this.trunks = null;
      this.loading$ = null;
      this.takeUntil$ = null;
      this.trunk$ = null;
      this.trunks$ = null;
    }
  }
}
